import React, { useEffect, useState } from "react"
import PrimaryButton from "../../../../components/molecules/buttons/PrimaryButton.molecule"
import Card from "../../../../components/atoms/Card.atom"
import { useLocation, useNavigate } from "react-router-dom"
import GridContainer from "../../../../components/layouts/containers/GridContainer.container"
import GridItem from "../../../../components/layouts/containers/GridItem.container"
import Divider from "../../../../components/atoms/Divider.atom"
import BadgePreview from "../components/BadgePreview"
import { getClient } from "../../../../services/client.service"
import useToast from "../../../../hooks/useToast.hook"
import { Skeleton } from "../../../../components/atoms/misc/Skeleton.atom"
import ClientProjects from "./ClientProjects.controller"
import { AppRoutes } from "../../../../consts/appRoutes.consts"
import { getTeamMembers } from "../../../../services/teamMember.service"
import ClientLogo from "../clientForm/formSections/ClientLogo.controller"

const ClientDetails = ({
  setShowClientFormModal,
  refresh,
  setSelectedClient,
}) => {
  const [client, setClient] = useState()
  const [teamMembers, setTeamMembers] = useState([])
  const [loading, setLoading] = useState(false)
  const { setErrorMessage } = useToast()
  const location = useLocation()
  const clientId = location?.state?.clientId
  const navigate = useNavigate()
  useEffect(() => {
    fetchData()
  }, [location?.state?.clientId, refresh])

  const fetchData = async () => {
    setLoading(true)
    try {
      await Promise.all([gettingClient(), gettingTeamMembers()])
    } catch (error) {
      setErrorMessage({ message: "Error al obtener los datos" })
      navigate(AppRoutes.clientes.index)
    } finally {
      setLoading(false)
    }
  }
  const gettingClient = async () => {
    const response = await getClient(clientId)
    if (!response.success) throw new Error("Error al obtener el cliente")
    const client = {
      ...location?.state.data,
      ...response.result.client,
      suggestedMonthlyBudget: 0,
      initialBudgetBalance: 0,
      budgetType: 1,
      projects: response.result.projects,
    }
    setClient(client)
    setSelectedClient(client)
  }

  const gettingTeamMembers = async () => {
    const response = await getTeamMembers()
    if (!response.success) throw new Error(response.message)
    const teamMembers = response.result
    setTeamMembers(teamMembers)
  }

  return (
    <Card className="client-details-view shadow-none w-full">
      <ClientInformationHeader
        client={client}
        setShowClientFormModal={setShowClientFormModal}
      />
      <ClientInformation client={client} loading={loading} setShowClientFormModal={setShowClientFormModal} />
      <Divider className="mt-0 mb-3" stroke="sm" />
      <ClientProjects
        client={client}
        teamMembers={teamMembers}
        loading={loading}
      />
    </Card>
  )
}

const ClientInformation = ({ client, loading, setShowClientFormModal = () => {} }) => {
  const renderJSXOrValue = (value) => {
    return React.isValidElement(value) ? value : (
        <span className="font-cairo text-3xl font-semibold">
          {value ?? "-"}
        </span>
      )
  }
  const titleContentTemplate = (title, value) => {
    return (
      <div className="flex flex-column h-full">
        <h3 className="font-mulish text-base font-semibold clr-secondary m-0">
          {title}
        </h3>
        {loading ?
          <Skeleton className="my-1 h-3rem flex-shrink-0" width="100%" />
        : renderJSXOrValue(value)}
      </div>
    )
  }
  return (
    <div className="flex gap-2 pb-3 align-items-center">
      <ClientLogo isClientView logoUrl={client?.logoUrl} clientName={client?.name} onEdit={() => setShowClientFormModal(true)}/>
      <Divider vertical/>
      <GridContainer className="w-full">
        <GridItem col={6} md={4}>
          {titleContentTemplate("ID", client?.id)}
        </GridItem>
        <GridItem col={6} md={4}>
          {titleContentTemplate("Nombre", client?.name)}
        </GridItem>
        <GridItem col={6} md={4}>
          {titleContentTemplate("Código", client?.code)}
        </GridItem>
        <GridItem col={6} md={4} className="flex flex-column h-5rem">
          {titleContentTemplate(
            "Indicador",
            <BadgePreview
              label={null}
              chipLabel={client?.code ?? "-"}
              color={client?.color}
              chipStyle={{
              margin: "0",
              }}
            />
          )}
        </GridItem>
        <GridItem col={6} md={4}>
          {titleContentTemplate(
            "Estatus",
            client?.active ? "Activo" : "Inactivo"
          )}
        </GridItem>
        <GridItem col={6} md={4}>
          {titleContentTemplate(
          "Tipo de presupuesto",
          client?.clientBudgetTypeName
        )}
        </GridItem>
    </GridContainer>
    </div>
  )
}

const ClientInformationHeader = ({ setShowClientFormModal, client }) => {
  return (
    <div className="flex align-items-center justify-content-between w-full mb-3">
      <h2 className="font-cairo font-semibold text-3xl">
        Detalles del cliente
      </h2>
      {client && (
        <PrimaryButton
          label="Editar"
          icon="pi pi-pencil"
          onClick={() => setShowClientFormModal(true)}
          btnType="outlined"
        />
      )}
    </div>
  )
}

export default ClientDetails
